module.exports = __webpack_public_path__ + "static/media/hearts.b1017903.svg";